<template>
  <el-drawer v-model="navigation.drawer" direction="rtl" :unique-opened="true" class="k-drawer">
    <div class="d-flex justify-content-center">
      <div>
        <img src="@/assets/logo/logo-reduccion.png" class="img-fluid pl-2" style="width: 120px" />
        <div class="w-100">KUDENIX</div>
      </div>
    </div>
    <el-divider></el-divider>
    <el-menu :router="true" @select="navigation.drawer = false">
      <el-menu-item index="search" :route="userStore.searchersLink" class="menu-item-text">
        <IconHomeSearch></IconHomeSearch>
        Buscadores
      </el-menu-item>
      <el-menu-item index="bookings" route="/booking" class="menu-item-text">
        <IconBookings></IconBookings>
        Reservas
      </el-menu-item>

      <el-sub-menu index="products">
        <template #title>
          <span class="menu-item-text">
            <IconProduct></IconProduct>
            Producto Kudenix
          </span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="products-1" route="/product/hotel">Hoteles</el-menu-item>
          <el-menu-item index="products-2" route="/product/transfer">Transportes</el-menu-item>

          <el-menu-item index="products-3" route="/product/ticket">Tickets</el-menu-item>
          <el-menu-item index="products-4" route="/product/insurance">Seguros</el-menu-item>
          <el-menu-item index="products-5" route="/place">Lugares</el-menu-item>
        </el-menu-item-group>
      </el-sub-menu>

      <el-menu-item index="logout" route="/logout" class="menu-item-text">
        <IconLogout></IconLogout>

        Logout
      </el-menu-item>
    </el-menu>
  </el-drawer>
</template>

<script setup>
import IconHomeSearch from '@/components/icons/IconHomeSearch.vue'
import IconProduct from '@/components/icons/IconProduct.vue'
import IconBookings from '@/components/icons/IconBookings.vue'
import IconLogout from '@/components/icons/IconLogout.vue'
import useNavigationStore from '@/stores/navigation.js'
import { ref, watch } from 'vue'
import { useUserStore } from '@/stores/user'

const navigation = useNavigationStore()
const drawer = ref(navigation.drawer)

const userStore = useUserStore()

watch(navigation.drawer, () => {
  drawer.value = navigation.drawer
})

</script>
